/**
 * Client portal tools. Day queues live on Inicio; this catalog is the six
 * in-module screens. Do not fold portal jobs into Quote.
 */
import type { LucideIcon } from 'lucide-react';
import {
  ClipboardList,
  FileCheck2,
  History,
  MapPin,
  PlusCircle,
  Wallet,
} from 'lucide-react';
import { PORTAL_ROUTES, ROUTES } from '../routes';
import {
  classifyPortalQuoteForDesk,
  isPortalShipmentActive,
} from './quoteDeskLogic';

export type { PortalQuoteDeskBucket } from './quoteDeskLogic';
export { classifyPortalQuoteForDesk, isPortalShipmentActive };

export interface PortalNavItemDef {
  id: string;
  labelKey: string;
  descriptionKey: string;
  icon: LucideIcon;
}

export function portalDeskPath(): string {
  return ROUTES.home;
}

export function portalSidebarSubItems(): PortalNavItemDef[] {
  const root = ROUTES.clientPortal;
  return [
    {
      id: `${root}/${PORTAL_ROUTES.newQuote}`,
      icon: PlusCircle,
      labelKey: 'portal.menu.newQuote',
      descriptionKey: 'portal.desk.newQuoteDescription',
    },
    {
      id: `${root}/${PORTAL_ROUTES.quoteHistory}`,
      icon: History,
      labelKey: 'portal.menu.quoteHistory',
      descriptionKey: 'portal.desk.quoteHistoryDescription',
    },
    {
      id: `${root}/${PORTAL_ROUTES.operationHistory}`,
      icon: ClipboardList,
      labelKey: 'portal.menu.operationsHistory',
      descriptionKey: 'portal.desk.operationsHistoryDescription',
    },
    {
      id: `${root}/${PORTAL_ROUTES.tracking}`,
      icon: MapPin,
      labelKey: 'portal.menu.tracking',
      descriptionKey: 'portal.desk.trackingDescription',
    },
    {
      id: `${root}/${PORTAL_ROUTES.pendingBalance}`,
      icon: Wallet,
      labelKey: 'portal.menu.balance',
      descriptionKey: 'portal.desk.balanceDescription',
    },
    {
      id: `${root}/${PORTAL_ROUTES.myDocuments}`,
      icon: FileCheck2,
      labelKey: 'portal.menu.myDocuments',
      descriptionKey: 'portal.desk.myDocumentsDescription',
    },
  ];
}

/** The six portal tools (day queues live on Inicio, not in this map). */
export const PORTAL_DESK_LINKS = portalSidebarSubItems();

